export const CMS_ADD_BANNER = 'classpass/cms_banner/ADD';
export const CMS_REMOVE_BANNER = 'classpass/cms_banner/REMOVE';

export const cmsAddBanner = () => ({ type: CMS_ADD_BANNER });
export const cmsRemoveBanner = () => ({ type: CMS_REMOVE_BANNER });
export const selectShouldShowCmsBanner = state => state.cmsBanner.shouldShowCmsBanner;

const initialState = {
  shouldShowCmsBanner: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CMS_ADD_BANNER: {
      return {
        ...state,
        shouldShowCmsBanner: true,
      };
    }

    case CMS_REMOVE_BANNER: {
      return {
        ...state,
        shouldShowCmsBanner: false,
      };
    }

    default:
      return state;
  }
}
